import { render, staticRenderFns } from "./deviceManage.vue?vue&type=template&id=065c5224&scoped=true"
import script from "./deviceManage.vue?vue&type=script&lang=js"
export * from "./deviceManage.vue?vue&type=script&lang=js"
import style0 from "./deviceManage.vue?vue&type=style&index=0&id=065c5224&prod&scoped=true&lang=deviceManage.scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c5224",
  null
  
)

export default component.exports